/**
 * Field Assist / org — screens. Organisation: positions, designations, field users, geography, admins and the masters hub.
 *
 * Every <Route path="…"> must be a string literal (scripts/check-nav.mjs reads them).
 * `/field/users` is still registered by modules/field/routes.tsx; its page
 * (pages/SetupPages.tsx FieldUsersPage) renders this area's FieldUsersPage.
 */
import { lazy, type ReactElement } from 'react';
import { Route } from 'react-router-dom';
import { RequireAnyPermission, RequirePermission } from '@/components/shared/RequirePermission';

const MastersHubPage = lazy(() => import('./MastersHubPage').then((m) => ({ default: m.MastersHubPage })));
const PositionsPage = lazy(() => import('./PositionsPage').then((m) => ({ default: m.PositionsPage })));
const GeographyPage = lazy(() => import('./GeographyPage').then((m) => ({ default: m.GeographyPage })));
const AdminsPage = lazy(() => import('./AdminsPage').then((m) => ({ default: m.AdminsPage })));
const DesignationsPage = lazy(() => import('./DesignationsPage').then((m) => ({ default: m.DesignationsPage })));

export function orgRoutes(): ReactElement[] {
  return [
    <Route key="org-masters" path="field/masters" element={<RequireAnyPermission modules={['field.master.position', 'field.master.user', 'field.master.geography', 'field.beat', 'field.outlet', 'field.distributor', 'master.product']} what="masters"><MastersHubPage /></RequireAnyPermission>} />,
    <Route key="org-positions" path="field/masters/positions" element={<RequirePermission module="field.master.position" what="positions"><PositionsPage /></RequirePermission>} />,
    <Route key="org-geography" path="field/masters/geography" element={<RequirePermission module="field.master.geography" what="geography"><GeographyPage /></RequirePermission>} />,
    <Route key="org-admins" path="field/masters/admins" element={<RequirePermission module="field.master.user" what="admins"><AdminsPage /></RequirePermission>} />,
    <Route key="org-designations" path="field/config/designations" element={<RequirePermission module="field.config" what="designations"><DesignationsPage /></RequirePermission>} />,
  ];
}
